import React from "react";

function FormError(props) {
  return <div className={props.className}>{props.children}</div>;
}

export default FormError;
